<div class="max-width-container min-h-[100vh] flex flex-col">
    <div id="header" class="sticky top-0 z-50 bg-white py-3 border-b-[1px] border-b-[#d5e5f6] lg:shadow-none shadow-sm">
        <header>
            <div class="xl:px-[100px] md:px-[6.9%]">
                <div class="md:px-0 px-6">
                    <div class="flex items-center justify-between w-full">
                        <div class="brand-logo-wrapper my-4">
                            <img class="w-[5.3rem] md:w-[8rem]" src="./assets/images/brand_logo.png" alt="TaxPod-logo" />
                        </div>
                        <div>
                            <button
                                (click)="skipSurvey()"
                                class="text-[#0B8EBB] text-base hover:underline"
                            >
                                {{ 'text.skip' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </div>

    <div class="flex-1 flex flex-col h-full">
        <router-outlet class="h-full w-full block"></router-outlet>
    </div>

    <app-footer/>
</div>
